<template>
  <div class="component screen screen__outbox">

    <outbox-header class="header"></outbox-header>

    <div class="accordion--contain">
      <full-screen-accordion v-model="activeName">

        <full-screen-accordion-item name="attachments">
          <span slot="headline">{{ $t('outboxStep1Title') }}</span>
          <h2 class="section__title">{{ $t('outboxStep1Heading') }}</h2>
          <outbox-attachments></outbox-attachments>
        </full-screen-accordion-item>

        <full-screen-accordion-item name="contact">
          <span slot="headline">{{ $t('outboxStep2Title') }}</span>
          <h2 class="section__title">{{ $t('outboxStep2Heading') }}</h2>
          <outbox-contact-info-form></outbox-contact-info-form>
        </full-screen-accordion-item>

        <full-screen-accordion-item name="review">
          <span slot="headline">{{ $t('outboxStep3Title') }}</span>
          <h2 class="section__title">{{ $t('outboxStep3Heading') }}</h2>
          <outbox-review-info></outbox-review-info>
        </full-screen-accordion-item>

        <full-screen-accordion-item name="send">
          <span slot="headline">{{ $t('outboxStep4Title') }}</span>
          <h2 class="section__title">{{ $t('outboxStep4Heading') }}</h2>
          <outbox-send-package></outbox-send-package>
        </full-screen-accordion-item>

      </full-screen-accordion>
    </div>

  </div>
</template>

<script>
  import router from '@/router';
  import i18n from '@/configured/vue-i18n';
  import FullScreenAccordion from '@/components/FullScreenAccordion.vue';
  import FullScreenAccordionItem from '@/components/FullScreenAccordionItem.vue';
  import OutboxContactInfoForm from '@/components/outbox/OutboxContactInfoForm.vue';
  import OutboxHeader from '@/components/outbox/OutboxHeader.vue';
  import OutboxReviewInfo from '@/components/outbox/OutboxReviewInfo.vue';
  import OutboxSendPackage from '@/components/outbox/OutboxSendPackage.vue';
  import OutboxAttachments from '@/components/outbox/OutboxAttachments.vue';

  export default {
    name: 'Outbox',
    data() {
      return {
        activeName: this.step || 'attachments'
      }
    },
    props: [
      'step'
    ],
    watch: {
      activeName,
      step() { this.activeName = this.step; this.setPageTitle(); }
    },
    methods: {
      setPageTitle
    },
    beforeMount(){ this.setPageTitle(); },
    components: {
      FullScreenAccordion,
      FullScreenAccordionItem,
      OutboxContactInfoForm,
      OutboxHeader,
      OutboxReviewInfo,
      OutboxSendPackage,
      OutboxAttachments
    }
  }

  //////////

  function setPageTitle() {
    const translationKey = `pageTitleOutbox`;
    const pageTitle = i18n.i18n.t(translationKey);
    const divider = i18n.i18n.t(`pageTitleDivider`);
    const siteName = i18n.i18n.t('siteName');
    if(this.activeName === 'attachments') {
      document.title = i18n.i18n.t('outboxStep1Title') + divider + siteName;
    }else if(this.activeName === 'contact') {
      document.title = i18n.i18n.t('outboxStep2Title') + divider + siteName;
    }else if(this.activeName === 'review') {
      document.title = i18n.i18n.t('outboxStep3Title') + divider + siteName;
    }else if(this.activeName === 'send') {
      document.title = i18n.i18n.t('outboxStep4Title') + divider + siteName;
    }else if(pageTitle === translationKey) {
      document.title = siteName;
    }else {
      document.title = pageTitle + divider + siteName;
    }
  }

  function activeName() {
    router.push({
      name: 'Outbox',
      params: {
        step: this.activeName
      }
    });
  }
</script>

<style lang="scss" scoped>

  .screen {

    &__outbox {
      display: flex;
      flex-direction: column;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }

</style>
